module.exports = __webpack_public_path__ + "static/media/marius.dd9a72f6.jpg";